module.exports = __webpack_public_path__ + "static/6Bell16-ecf4427275c8ab7886ca6300134ce091.jpg";